import React from 'react';
import axios from 'axios';
import {
    Grid,
    Button
} from '@material-ui/core/';
import { ModalInput } from './common';

type StornoText = {
    header: string;
    lineOne: string;
    lineTwo: string;
    lineThree: string;
    lineFour: string;
    lineFive: string;
    lineSix: string;
    lineSeven: string;
}

type StornoTextVariant = 
    'header' 
    | 'lineOne' 
    | 'lineTwo' 
    | 'lineThree' 
    | 'lineFour' 
    | 'lineFive' 
    | 'lineSix' 
    | 'lineSeven'

interface Props {
    stornoText: StornoText;
    setStornoText: React.Dispatch<React.SetStateAction<StornoText>>;
    stornoTextId: string,
    onClose: () => void,
    API: string
}

function EditStornoTextModal( props: Props ) {
    const { 
        stornoText, 
        setStornoText,
        stornoTextId,
        onClose,
        API
    } = props

    const handleStornoTextChange = (variant: StornoTextVariant) => {
        const handleChange = (e: string) => setStornoText({
            header: variant === 'header' ? e : stornoText.header,
            lineOne: variant === 'lineOne' ? e : stornoText.lineOne,
            lineTwo: variant === 'lineTwo' ? e : stornoText.lineTwo,
            lineThree: variant === 'lineThree' ? e : stornoText.lineThree,
            lineFour: variant === 'lineFour' ? e : stornoText.lineFour,
            lineFive: variant === 'lineFive' ? e : stornoText.lineFive,
            lineSix: variant === 'lineSix' ? e : stornoText.lineSix,
            lineSeven: variant === 'lineSeven' ? e : stornoText.lineSeven,
        })

        return handleChange
    }

    const onSubmit = () => {
        axios.patch(`${API}stornoText/${stornoTextId}`, stornoText).catch(err => console.log('Error: ' + err));
        onClose();
    }

    return (
        <form onSubmit={onSubmit}>
            <Grid container direction='column' style={{ width: '30vw', minWidth: '270px'}}>
                <ModalInput value={stornoText.header} onChange={handleStornoTextChange('header')} multiline />
                <ModalInput value={stornoText.lineOne} onChange={handleStornoTextChange('lineOne')} multiline />
                <ModalInput value={stornoText.lineTwo} onChange={handleStornoTextChange('lineTwo')} multiline />
                <ModalInput value={stornoText.lineThree} onChange={handleStornoTextChange('lineThree')} multiline />
                <ModalInput value={stornoText.lineFour} onChange={handleStornoTextChange('lineFour')} multiline />
                <ModalInput value={stornoText.lineFive} onChange={handleStornoTextChange('lineFive')} multiline />
                <ModalInput value={stornoText.lineSix} onChange={handleStornoTextChange('lineSix')} multiline />
                <ModalInput value={stornoText.lineSeven} onChange={handleStornoTextChange('lineSeven')} multiline />
                <Grid container justify='center' style={{ padding: '8px'}}>
                    <Button 
                        variant='contained' 
                        color='primary'
                        onClick={() => onSubmit()}
                    >
                        Uložit
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default EditStornoTextModal;